import React, {ReactNode} from 'react';
import {createPortal} from 'react-dom';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {useFrame} from 'context/frame';
import {StepStatus} from '../types';
import {WebcamProps, WebcamRefTypes} from 'components/Webcam';
import {CustomIcon} from '@guestapp/ui';
import {
  BackIconButton,
  ChallengeProgressBarStyled,
  MobileLivenessInstructions,
  StyledWebcam,
  Title,
  Wrapper,
} from './styled';

export type MobileCameraProps = WebcamProps & {
  disabled: boolean;
  status?: StepStatus;
  addon?: ReactNode;
};
const MobileWebcam = React.forwardRef<WebcamRefTypes, MobileCameraProps>(
  ({status, addon, ...props}, ref) => {
    const navigate = useNavigate();
    const {document: frameDocument} = useFrame();
    const rootElement = frameDocument?.body || document.body;
    const {t} = useTranslation();
    const onBack = () => navigate(-1);

    return createPortal(
      <Wrapper $status={status} className="mobile-camera">
        <BackIconButton onClick={onBack} className="mobile-camera__back-btn">
          <CustomIcon size={20} name="backBlueArrow" color="white" />
        </BackIconButton>
        <Title className="mobile-camera__title">{t('face_check')}</Title>
        <StyledWebcam ref={ref} {...props} />
        <ChallengeProgressBarStyled />
        <MobileLivenessInstructions />
        {addon}
      </Wrapper>,
      rootElement,
    );
  },
);

export {MobileWebcam};
